
import React from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import {Tabs, Tab} from 'material-ui/Tabs';
import LinearProgress from 'material-ui/LinearProgress';
import muiThemeable from 'material-ui/styles/muiThemeable';
import * as colors from 'material-ui/styles/colors';
import 'whatwg-fetch';
import {AmsAPIEndpointURL} from '../constants';
import {postFile} from '../util/fetch';
import Dropzone from 'react-dropzone';

class PhotoUpload extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      tabValue: 'upload',
      url: '',
      file: null,
      verifyInProgress: false,
      validUrl: false,
      urlStateErrorText: '',
      preview: null,
    };
    this.onUpdateURL = this.onUpdateURL.bind(this);
    this.verifyUrl = this.verifyUrl.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onUpdateURL = this.onUpdateURL.bind(this);
    this.onFileSelected = this.onFileSelected.bind(this);
  }
  handleClose = () => {
    if (this.props.closeDialog){
      this.props.closeDialog();
    }
  };

  onDrop = async (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      this.setState({preview: file.preview});
      var data = new FormData();
      data.append('file', file);

      const amsPostResult = await postFile(`${AmsAPIEndpointURL}/assets`, {
        method: 'POST',
        body: data
      });

      if (amsPostResult.status === 201){
          let amsData = await amsPostResult.json();
          this.setState({amsData, url: amsData.href, fileReady:true});
      }
    }
  }

  handleSubmit() {
    if (this.props.photoReady){
      let url = this.state.url;
      this.props.photoReady(url, this.state.amsData);
    }
    if (this.props.closeDialog){
      this.props.closeDialog();
    }
  }

  verifyUrl() {
    const self = this;
    fetch(this.state.url)
      .then(result => {
        if (result.status === 200) {
          self.setState({validUrl:true, verifyInProgress: false, urlStateErrorText: '', amsData: self.getAmsData(self.state.url)})
        } else {
          self.setState({validUrl:false, verifyInProgress: false, urlStateErrorText: `URL is not valid, returned ${result.status}`})
        }
      })
      .catch(err=>{
        self.setState({validUrl:false, verifyInProgress: false, urlStateErrorText: 'URL is not valid'})
      })
  }

  getAmsData(url) {

    const filename = url.split('/').pop().split('#')[0].split('?')[0];
    const filenameNoExt = filename.substring(0,filename.lastIndexOf('.'));

    if (url.indexOf(url) >= 0 && url.indexOf('blob.core.windows.net') >= 0) {
      return {
        id: filenameNoExt, //ams image id
        href: url,
        name: filename
      }
    } else {
      return {
        id: '',
        href: url,
        name: filename
      }
    }
  }

  onUpdateURL = (event) => {
    this.setState({url: event.target.value, validUrl: false, amsData: null, fileReady:false});
  }

  async onFileSelected(event){
    const file = event.target.files[0];

    var data = new FormData();
    data.append('file', file);

    const amsPostResult = await postFile(`${AmsAPIEndpointURL}/assets`, {
      method: 'POST',
      body: data
    });

    if (amsPostResult.status === 201){
        let amsData = await amsPostResult.json();
        this.setState({amsData, url: amsData.href, fileReady:true});
    }
  }

  render() {

    let actionEnabled = (
      (this.state.tabValue === 'upload' && this.state.fileReady) ||
      (this.state.tabValue === 'url' && this.state.validUrl)
    )

    const underlineStyle = {
      borderColor: colors.green500,
    };

    const styles = {
      primaryButton: {
        borderRadius: '4px',
        minHeight: 46,
        fontSize: 18,
        fontWeight: '600',
        textTransform: 'capitalize',
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 56,
      }
    }

    const actions = [
      <FlatButton
        label="Cancel"
        primary={false}
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        disabled={!actionEnabled}
        label="Upload"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.handleSubmit}
      />,
    ];
    let dropzoneRef;
    return (
      <Dialog
          title="Upload Photo"
          titleStyle={{ fontWeight:600, textAlign:'center' }}
          contentClassName={'dialog-box'}
          actionsContainerClassName={'dialog-btns'}
          actions={actions}
          modal={true}
          open={this.props.show}
          autoDetectWindowHeight={true}
          onRequestClose={this.handleClose}
      >
        <div style={{ height:'auto' }}>
        <Tabs
          className={'photoUpload'}
          contentContainerClassName="photoUploadContentContainer"
          tabItemContainerStyle={{ width:'580px', background:'white', borderBottom:'1px solid #d4d4d4', height:'40px' }}
          style={{ background:'#FFF' }}
          contentContainerStyle={{ background:'#FFF' }}
          value={this.state.tabValue}
          onChange={(tabValue)=>this.setState({tabValue})}
        >
          {/* Upload from Computer */}
          <Tab label="Upload Image" value="upload" style={{ color:'#5f5e5e', textTransform:'none' }}>
            <br/>
            <Dropzone onDrop={this.onDrop} ref={(node) => { dropzoneRef = node; }}  style={{ cursor:'pointer', height:100, width:'80%', background:'#F7F7F7', color:'#B7B7B7', border:'2px dotted #D7D7D7', borderRadius:4, marginBottom:12 }}>
              {this.state.preview?
                <img src={this.state.preview} style={{ width:'auto', height:'auto', margin:5, maxHeight:90, maxWidth:540 }} alt=""/>
                :
                <span>
                  <i className={'icon-icon-upload'} style={{ fontSize:18, marginRight:8, color:'#D7D7D7', verticalAlign:'text-top' }}></i>
                  <font style={{ fontWeight:600, fontStyle:'italic' }}>Drop a file here to upload</font>
                </span>
              }
            </Dropzone>
            <div className={'or-line-break'}>
              OR
            </div>
            <div style={{ textAlign:'right' }}>
              <FlatButton style={{ marginTop:-2, height:46 }} labelStyle={{ fontSize:17, fontWeight:600, color:'#09B0FF', textTransform:'capitalize' }} onClick={() => { dropzoneRef.open() }} label="Browse Files" />
            </div>
          </Tab>

          {/* Link to Image */}
          <Tab label="Specify URL" value="url"  style={{color:'#5f5e5e', textTransform: 'none'}}>
            <TextField
              defaultValue=""
              errorText={this.state.urlStateErrorText}
              floatingLabelText="Image URL"
              style={{ width:580, marginBottom:20 }}
              underlineStyle={this.state.validUrl? underlineStyle : null}
              onChange={this.onUpdateURL}
            />
            <RaisedButton buttonStyle={styles.primaryButton} labelStyle={styles.primaryButton} overlayStyle={styles.primaryButton} label="Verify" primary="true" onTouchTap={this.verifyUrl}/> <br/><br/>
            {this.state.verifyInProgress? <LinearProgress mode="indeterminate" color={this.props.muiTheme.palette.accent2Color}/>:null}
          </Tab>
        </Tabs>
        </div>
      </Dialog>
    );
  }
}

export default muiThemeable()(PhotoUpload)



// WEBPACK FOOTER //
// ./src/containers/PhotoUpload.js